import React from "react";
import { useField } from "formik";

export const RequiredTextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div
      className={
        meta.touched && meta.error
          ? "form-group row has-danger"
          : "form-group row"
      }
    >
      <label className="lead" htmlFor={props.id || props.name}>
        {label}
      </label>
      <input
        className="form-control"
        placeholder="Enter your answer"
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="form-control-feedback">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const TextInput = ({ label, ...props }) => {
  const [field] = useField(props);
  return (
    <div className="form-group row">
      <label className="lead" htmlFor={props.id || props.name}>
        {label}
      </label>
      <input
        className="form-control"
        placeholder="Enter your answer"
        {...field}
        {...props}
      />
    </div>
  );
};

export const RequiredTextAreaInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div
      className={
        meta.touched && meta.error
          ? "form-group row has-danger"
          : "form-group row"
      }
    >
      <label className="lead" htmlFor={props.id || props.name}>
        {label}
      </label>
      <textarea
        className="form-control"
        placeholder="Enter your answer"
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="form-control-feedback">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const TextAreaInput = ({ label, ...props }) => {
  const [field] = useField(props);
  return (
    <div className="form-group row">
      <label className="lead" htmlFor={props.id || props.name}>
        {label}
      </label>
      <textarea
        className="form-control"
        placeholder="Enter your answer"
        {...field}
        {...props}
      />
    </div>
  );
};

export const MyCheckbox = ({ children, ...props }) => {
  const [field] = useField(props);
  return (
    <div className="form-group row">
      <label className="lead" {...field} {...props}>
        {props.title}
        {children}
      </label>
    </div>
  );
};

export const MyRequiredCheckbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className="form-group row">
      <label className="lead" {...field} {...props}>
        {props.title}
        {children}
      </label>
      {meta.touched && meta.error ? (
        <div className="form-control-feedback">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const MySelect = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div
      className={
        meta.touched && meta.error
          ? "form-group row has-danger"
          : "form-group row"
      }
    >
      <label htmlFor={props.id || props.name} className="lead">
        {label}
      </label>
      <select className="form-control" {...field} {...props}></select>
      {meta.touched && meta.error ? (
        <div className="form-control-feedback">{meta.error}</div>
      ) : null}
    </div>
  );
};

export const DataSheetInput = ({ label, ...props }) => {
  const [field] = useField(props);
  return (
    <div className="form-group row">
      <div
        className="col-5"
        style={{ display: "flex", justifyContent: "right" }}
      >
        <label className="lead" htmlFor={props.id || props.name}>
          {label}
        </label>
      </div>
      <div
        className="col-2"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div>
          {/* <input
            className="form-control"
            type="text"
            autoComplete="off"
            id={this.props.inputId}
            placeholder={this.props.inputValue}
            disabled={this.props.inputType === "calc" ? true : false}
          ></input> */}
          <input
            className="form-control"
            placeholder="Enter your answer"
            {...field}
            {...props}
          />
        </div>
      </div>
      <div
        className="col-5"
        style={{ display: "flex", justifyContent: "left" }}
      >
        <p>{this.props.comment}</p>
      </div>
    </div>
  );
};
